import service from "@/store/services/cash-register-reading-items-service";

export const state = () => ({
  list: {},
  cashRegisterReadingItem: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, cashRegisterReadingItem) => {
    state.cashRegisterReadingItem = cashRegisterReadingItem;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((cashRegisterReadingItem) => {
      commit("SET_RESOURCE", cashRegisterReadingItem);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((cashRegisterReadingItem) => {
      commit("SET_RESOURCE", cashRegisterReadingItem);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((cashRegisterReadingItem) => {
      commit("SET_RESOURCE", cashRegisterReadingItem);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  cashRegisterReadingItem: (state) => state.cashRegisterReadingItem,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((cashRegisterReadingItem) => ({
      id: cashRegisterReadingItem.id,
      name: ``,
    }));
  },
};

const cashRegisterReadingItems = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default cashRegisterReadingItems;
